export default __webpack_public_path__ + "static/media/1759.3479b71a.png";